import React, { useState } from "react";

import Permissonheader from "./Permissonheader";
import AdminPermision from "./AdminPermision";
import PractitionerPermission from "./Practitionerpermisson";

const RolesPermission = () => {
  const [adminShow, setAdminShow] = useState(true);

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">

      <Permissonheader setAdminShow={setAdminShow} />

      {adminShow ? <AdminPermision />  : <PractitionerPermission />}
    </div>
  );
};

export default RolesPermission;
